// client/src/components/Card.js
import React from 'react';
import './Card.css';

const Card = ({ 
  card, 
  onClick, 
  selected, 
  playable = true,
  isArranging = false,
  arrangementIndex = 0 
}) =>  {
  if (!card) return null;

  const getCardColor = () => {
    if (card.suit === 'hearts' || card.suit === 'diamonds') return 'red';
    if (card.suit === 'clubs' || card.suit === 'spades') return 'black';
    return 'joker'; // for jokers
  };

  const getSuitSymbol = () => {
    switch (card.suit) {
      case 'hearts': return '♥';
      case 'diamonds': return '♦';
      case 'clubs': return '♣';
      case 'spades': return '♠';
      default: return '★'; // joker
    }
  };

  const getValueDisplay = () => {
    if (card.value === 'Joker') return 'JOK';
    if (card.value === 'A') return 'A';
    if (card.value === 'K') return 'K';
    if (card.value === 'Q') return 'Q';
    if (card.value === 'J') return 'J';
    return card.value;
  };

   return (
    <div
      className={`card ${getCardColor()} ${selected ? 'selected' : ''} ${
        playable ? 'playable' : 'unplayable'
      } ${isArranging ? 'arranging-card' : ''} transition-all`}
      onClick={playable ? onClick : null}
      style={{
        animationDelay: isArranging ? `${arrangementIndex * 50}ms` : '0ms',
        zIndex: selected ? 100 : arrangementIndex
      }}
    >
      <div className="card-top">
        <span className="card-value">{getValueDisplay()}</span>
        <span className="card-suit">{getSuitSymbol()}</span>
      </div>
      <div className="card-center">
        <span className="card-suit-large">{getSuitSymbol()}</span>
      </div>
      <div className="card-bottom">
        <span className="card-value">{getValueDisplay()}</span>
        <span className="card-suit">{getSuitSymbol()}</span>
      </div>
    </div>
  );
};

export default Card;